import { render, staticRenderFns } from "./ScreenTwo.vue?vue&type=template&id=55798e0c&"
import script from "./ScreenTwo.vue?vue&type=script&lang=js&"
export * from "./ScreenTwo.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTwo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports